var getCardatronCards, ls_ttl, service, setCards, ttl_ms,
  hasProp = {}.hasOwnProperty;

ls_ttl = require('localstorage-ttl');

service = 'cards';

ttl_ms = 1000 * 60 * 60;

setCards = function(data) {
  var $navContainer, $subNavCardatron, cuiClass, key, results, tilesLeft, value;
  results = [];
  for (key in data) {
    if (!hasProp.call(data, key)) continue;
    value = data[key];
    $navContainer = $(".subnav .subnav-flyout." + key + "-tab-flyout");
    $subNavCardatron = $navContainer.find('.subnav-cardatron');
    if ($subNavCardatron.length > 0) {
      $subNavCardatron.html(value);
      tilesLeft = 4 - $navContainer.find('.subnav-categories').length;
      cuiClass = (function() {
        switch (tilesLeft) {
          case 4:
            return 'cui-four-up';
          case 3:
            return 'cui-three-up';
          default:
            return 'cui-two-up';
        }
      })();
      results.push($subNavCardatron.addClass(cuiClass).find(".cui-c-collection-tile:gt(" + (tilesLeft - 1) + ")").remove());
    } else {
      results.push(void 0);
    }
  }
  return results;
};

getCardatronCards = function() {
  var attributes, cacheData, cll, ell, storageKey;
  ell = Cookie.get('ell');
  cll = Cookie.get('cll');
  storageKey = 'sls_cardatron_cards';
  cacheData = ls_ttl.get(storageKey);
  if ((cacheData != null) && (cacheData.ell === ell && cacheData.cll === cll)) {
    setCards(cacheData.cards);
    return;
  }
  attributes = {
    service: service,
    ell: ell,
    cll: cll,
    c: Cookie.get('c'),
    b: Cookie.get('b')
  };
  $.ajax({
    type: 'GET',
    url: '/layout/calls/service',
    timeout: 5000,
    data: attributes,
    success: function(arg) {
      var cacheValue, data, err;
      data = arg.data, err = arg.err;
      if (err != null) {
        return;
      }
      cacheValue = {
        cll: cll,
        ell: ell,
        cards: data
      };
      ls_ttl.set(storageKey, cacheValue, ttl_ms);
      return setCards(data);
    }
  });
};

module.exports = {
  getCardatronCards: getCardatronCards
};

